<div class="admin-container" [hidden]="!isLoaded">

  <mat-toolbar class="no-background">
    <span>【管理者用】週報</span>
    <span class="spacer"></span>
    <a mat-button class="add-link" routerLink="/admin">
      <mat-icon>arrow_back</mat-icon>戻る
    </a>
  </mat-toolbar>

  <div *ngIf="data">
    <div style="display: flex; justify-content: space-around; border: 1px solid #ccc; border-radius: 8px; padding: 8px;">
      <button matFab (click)="changeAd(prevAd)">◀</button>
      <div style="margin-top: 9px;">{{ym}}の週報</div>
      <button matFab (click)="changeAd(nextAd)">▶</button>
      <mat-checkbox [(ngModel)]="data[0].is_public" style="margin-right: 32px;">
        公開状態
      </mat-checkbox>
      <button mat-raised-button color="primary" type="button" (click)="save()" [disabled]="!this.data">保存する</button>
    </div>

    <table>
      <tr>
        <th style="width: 333px; text-align: center;">
          月報で使用する為替レートを入力してください
          <div *ngIf="!!monthly" style="color: orange;">※月報データが存在しているのでレートの変更はできません</div>
        </th>
        <th style="text-align: center;">CHF/JPY</th><td><app-decimal-input [(ngModel)]="data[4].meta['CHFJPY']" [scale]="3" [readonly]="!!monthly" [inputStyle]="'border: 4px solid red;'"></app-decimal-input></td>
        <th style="text-align: center;">USD/JPY</th><td><app-decimal-input [(ngModel)]="data[4].meta['USDJPY']" [scale]="3" [readonly]="!!monthly" [inputStyle]="'border: 4px solid red;'"></app-decimal-input></td>
        <th style="text-align: center;">AUD/JPY</th><td><app-decimal-input [(ngModel)]="data[4].meta['AUDJPY']" [scale]="3" [readonly]="!!monthly" [inputStyle]="'border: 4px solid red;'"></app-decimal-input></td>
        <th style="text-align: center;">GBP/JPY</th><td><app-decimal-input [(ngModel)]="data[4].meta['GBPJPY']" [scale]="3" [readonly]="!!monthly" [inputStyle]="'border: 4px solid red;'"></app-decimal-input></td>
        <th style="text-align: center;">EUR/JPY</th><td><app-decimal-input [(ngModel)]="data[4].meta['EURJPY']" [scale]="3" [readonly]="!!monthly" [inputStyle]="'border: 4px solid red;'"></app-decimal-input></td>
      </tr>
    </table>

    <table style="font-size: 12px;">
      <thead>
        <tr>
          <th style="width: 333px; text-align: center;">POOL type・月初残高・通算</th>

          @for (idx of periodIndex; track idx;) {
            <td>
              第{{idx + 1}}週　<input type="text" [(ngModel)]="data[idx].from" style="width: 4em; padding: 2px;"> ～ <input type="text" [(ngModel)]="data[idx].to" style="width: 4em; padding: 2px;">
            </td>
          }
        </tr>
      </thead>
      @for (type of poolTypes; track type) {
        <tr>
          <th rowspan="2">
            <table class="inner-table" border="0" cellpadding="0" cellspacing="0">
              <tr style="vertical-align: top;">
                <td style="font-size: 18px;">{{type}}</td>
                <td colspan="2" style="text-align: right;">
                  月初残高（円・参考値）
                  <app-decimal-input [(ngModel)]="data[4].reports[type].beginning_balance" [scale]="8" [displayScale]="2" [inputStyle]="'width: 110px;'" [readonly]="true"></app-decimal-input>
                </td>
              </tr>
              <tr><td colspan="3">通算</td></tr>
              <tr><td>トレード損益率</td><td>スワップ損益率</td><td>合計損益率</td><td></td></tr>
              <tr>
                <td><app-decimal-input [(ngModel)]="data[4].reports[type].trade_per" [scale]="8" [inputStyle]="'width: 90px;'"></app-decimal-input></td>
                <td><app-decimal-input [(ngModel)]="data[4].reports[type].swap_per" [scale]="8" [inputStyle]="'width: 90px;'"></app-decimal-input></td>
                <td><app-decimal-input [(ngModel)]="data[4].reports[type].sum_per" [scale]="8" [inputStyle]="'width: 90px; border: 4px solid red;'"></app-decimal-input></td>
                <td><span class="small">％</span></td>
              </tr>
            </table>
          </th>
            @for (idx of periodIndex; track idx;) {
              <td class="weekly">
                <table class="inner-table" border="0" cellpadding="0" cellspacing="0">
                  <tr><td>トレード損益率</td><td>スワップ損益率</td><td>合計損益率</td><td></td></tr>
                  <tr>
                    <td><app-decimal-input [(ngModel)]="data[idx].reports[type].trade_per" [scale]="8" [inputStyle]="'width: 90px;'"></app-decimal-input></td>
                    <td><app-decimal-input [(ngModel)]="data[idx].reports[type].swap_per" [scale]="8" [inputStyle]="'width: 90px;'"></app-decimal-input></td>
                    <td><app-decimal-input [(ngModel)]="data[idx].reports[type].sum_per" [scale]="8" [inputStyle]="'width: 90px;'"></app-decimal-input></td>
                    <td><span class="small">％</span></td>
                  </tr>
                </table>
              </td>
            }
        </tr>
        <tr>
          <td colspan="4">
            <textarea rows="3" [(ngModel)]="data[4].reports[type].comment" style="width: 98%;" placeholder="（コメントを入力）"></textarea>
          </td>
        </tr>
      }

    </table>

  </div>

</div>

